import * as React from "react";
import { Static } from "@bizform/type/decorator/Static.decorator";
import { ComponentElement, ComponentElementStatic } from "@bizform/type/model/component_element/ComponentElement.model";
import { PluginType } from "@bizform/type/model/model/Plugin.model";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import { Debug } from "@bizform/helper/dist/js/bizflow/helper.min";
import { ComponentElementClass, ReactComponentElementInit } from "@bizform/core/dist/js/bizflow/core.min";


type State =  {
    show: boolean;
    label: string;
};

/**
 * Embed Form component element
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
@ComponentElementClass()
@Static<ComponentElementStatic<null>>()
export class BfZRegion extends React.Component<null, State> implements ComponentElement<null> {
    static readonly pluginType: string = PluginType.CUSTOMHTMLHANDLER;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_GaeRN8H7Kxd_DfF3fC3kIfBHVxoXl0O",
        category: ComponentCategory.HANDLER,
        label: "Region for Accessibility",
        description: "Region for Accessibility",
        icon: "",
        property: null
    };

    destroyed: boolean;
    accessibility: boolean;
    elementId: string;
    applicationId: string;
    formId: string;
    parentDom: HTMLElement;

    /** action */
    onDisabled() {
        this._show();
    }
    onReadOnly() {
        this._show();
    }
    onPrint() {
        this._show();
    }
    onEdit() {
        this._show();
    }

    focus() {}

    setProperty(property: ComponentElementProperty) {
        try {
            this.setState({
                show: this.state.show,
                label: property.attribute.label.value
            });
        } catch (e) {
            Debug.console.error("setProperty", e);
        }
    }

    noDisplayInheritance() {
    }

    @ReactComponentElementInit(BfZRegion)
    static init(): ComponentElement<string> {
        return;
    }

    initDone(): void {
    }

    destroy(): void {
        this.destroyDone();
    }

    destroyDone(): void {
    }

    emitHasContainerKey(): void {
    }

    /* for React */
    state: State;

    static defaultProps = {
    };

    constructor(props?: any) {
        super(props);
        this.state = {
            show: false,
            label: ""
        };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        Debug.console.error(error, errorInfo);
    }

    render(): React.ReactNode {
        if (!this.state.show) {
            return null;
        } else {
            return (
                <div role="region" aria-label={this.state.label} className="bf-text-red5">
                    <i className="fas fa-exclamation"></i>
                    <span aria-hidden={true}> {this.state.label}</span>
                </div>
            );
        }
    }

    private _show() {
        this.setState({
            show: true
        });
    }
}
